import React from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useModelStatuses } from './hooks/useModelStatuses';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const ModelStatusFilter = () => {
  const { filterValues, updateFilter, isShowAll } = useFilters();
  const showAllEnabled = isShowAll('modelStatus');
  const modelStatuses = useModelStatuses(showAllEnabled);

  useFilterInitialization('modelStatus', modelStatuses, {
    waitForData: true,
    getDefaultValue: () => SHOW_ALL_OPTION,
    getParams: (item) => ({ modelStatus: item.id })
  });

  if (!filterValues.modelStatus) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={modelStatuses}
        columns={[{ name: "name", id: 1, minWidth: "130px" }]}
        columnsMinWidths={[140, 140, 140, 140, 140]}
        showHeader={false}
        width="100%"
        placeholder="Select Status"
        onChange={item => updateFilter('modelStatus', item, { modelStatus: item.id })}
        selectdValueToshow="name"
        selectedValue={filterValues.modelStatus?.value}
        label="Filter by Status"
        isServerSide={false}
        icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
        required={false}
        showBorderColor
      />
    </Grid>
  );
}; 
